import { ReactNode } from 'react';
import { UiCautionTriangleFilled } from '@cof/omni-gravity-icons-react';
import { Box as OmniBox, Icon, Row } from '@cof/omni-react';
import { colorBackgroundStatusWarning } from '@cof/omni-tokens';

export const WarningBox = ({
  children,
  ...restOfProps
}: {
  children: ReactNode;
}) => {
  return (
    <OmniBox
      {...restOfProps}
      style={{
        padding: '5px 20px 20px',
        textAlign: 'left',
        backgroundColor: colorBackgroundStatusWarning,
      }}
    >
      <Row justifyContent="flex-start" wrap="nowrap" alignItems="stretch">
        <Icon
          style={{ marginTop: '10px' }}
          svg={UiCautionTriangleFilled}
          color="warning"
        />
        <div
          style={{
            marginLeft: '10px',
          }}
        >
          {children}
        </div>
      </Row>
    </OmniBox>
  );
};
